import React, { useEffect, useRef } from 'react';

interface LogoutTimerProps {
  timeout: number;
  onLogout: () => void;
}

const LogoutTimer: React.FC<LogoutTimerProps> = ({ timeout, onLogout }) => {
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const reset = () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
      timeoutIdRef.current = setTimeout(() => {
        onLogout();
      }, timeout);
    };

    const handleMouseActivity = () => {
      reset();
    };

    document.addEventListener('mousemove', handleMouseActivity); // Add event listener for mousemove event

    reset();

    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
      document.removeEventListener('mousemove', handleMouseActivity); // Remove event listener on cleanup
    };
  }, [timeout, onLogout]);

  return null;
};

export default LogoutTimer;
